import * as Yup from 'yup';
import { SubCustomersRequestStatus } from '../../../models/subCustomersRequest';

export const updateSubCustomersRequestValidation = Yup.object().shape({
  requestStatus: Yup.string()
    .required()
    .oneOf(Object.values(SubCustomersRequestStatus)),
});
